<div class="issue-currency-picker">
  <div class="flex-center-between">
    <h2 class="text-header-18">Generar presupuesto</h2>
    <app-st-icon data-test="issue-currency-close" (click)="cancel()" class="cursor-pointer" name="close" [bold]="true"></app-st-icon>
  </div>

  <div>
    <span class="text-label-10">{{ model.label }}</span>
    <nz-select
      class="issue-currency-picker__select"
      nzSize="large"
      nzShowSearch
      nzPlaceHolder="Selecciona una moneda"
      [(ngModel)]="selectedId"
    >
      <nz-option *ngFor="let option of model.options" [nzValue]="option.id" [nzLabel]="option.label"></nz-option>
    </nz-select>
  </div>

  <div class="flex-center-between footer">
    <button data-test="issue-currency-cancel" nz-button nzType="text" nzShape="round" nzSize="large" (click)="cancel()">
      Cancelar
    </button>
    <button data-test="issue-currency-generate" class="generate-button" nz-button nzType="primary" nzShape="round"
      nzSize="large" [disabled]="selectedId === null" (click)="generate()">
      Generar
    </button>
  </div>
</div>
